import React from 'react'

const Name = () => {
  return (
    <>
      <span>Shalom Springs Of Plano</span>
    </>
  )
}

export default Name